<template>
  <div class="filter-tpl-pro jzliu-bi-filter-tpl-pro">
    <filter-group
      :disabled="disabled"
      :codeListMap="codeListMap"
      :filters="filters"
      :isFieldFlag="isFieldFlag"
      :fieldGroupName="fieldGroupName"
      class="mb-[8px]"
      style="margin-bottom: 8px"
      :negated="filterParentNegated"
      @negatedChange="negatedChange"
      :rightTypeHttpFlag="rightTypeHttpFlag"
      v-bind="$attrs"
      :groupIndex="groupIndex"
      :isMarkErr="isMarkErr"
      v-for="(group, groupIndex) in filters"
      :isShowAllCondition="isShowAllCondition"
      :filterGroup="group"
      :originCodeListMap="$attrs.codeListMap"
    ></filter-group>
    <div
      v-if="!isFieldFlag && !disabled"
      class="text-[18px] flex items-center"
      style="font-size: 18px"
    >
      <div
        @click="btnAddGroup"
        class="cursor-pointer"
        style="display: inline-block; cursor: pointer"
      >
        <el-button icon="el-icon-circle-plus-outline" size="mini" type="text">
          <span>添加条件组</span>
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import filterGroup from "./tpl/filterGroup.vue";
import { createFilterGroupItem } from "./enum.data";
import { getUUID, deepClone } from "./utils";

/****
 * 内部传入的字段格式需遵循
 * @params fieldName 字段中文名
 * @params field 字段物理名
 * @params fieldId 字段id
 * @params fieldType 英文字段类型
 * @params fieldTypeCn 中文字段类型
 * @params groupName 分组需要的字段
 * @params groupId 分组需要的字段
 * @params tableName 字段关联的表名
 * **/

export default {
  name: "filter-tpl-pro",
  components: { filterGroup },
  props: {
    isDialog: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    // 字段选择多级的分组字段
    fieldGroupName: {
      type: String,
      default: "",
    },
    // 是否右侧值需要匹配左侧字段类型
    rightTypeHttpFlag: {
      type: Boolean,
      default: false,
    },
    negated: {
      type: String,
      default: "N",
    },
    value: {
      type: Array,
      default: () => [],
    },
    isRequired: {
      type: Boolean,
      default: true,
    },
    isMarkErr: {
      type: Boolean,
      default: false,
    },
    isShowAllCondition: {
      type: Boolean,
      default: true,
    },
    tips: {
      type: String,
      default: "过滤条件",
    },
    // 是否只允许一条field
    isFieldFlag: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    negated() {
      this.filterParentNegated = this.negated;
    },
    value: {
      deep: true,
      immediate: true,
      handler(val) {
        this.filters = this.isDialog ? JSON.parse(JSON.stringify(val)) : val;
      },
    },
    // filters: {
    //   handler(val){
    //     this.$emit('judgeDelete', val )
    //   },deep: true
    // }
  },
  data() {
    return {
      codeListMap: {},
      filterParentNegated: "N",
      getUUID,
      filters: [],
    };
  },
  mounted() {
    console.log("index-mounted:", this.value);
    this.filterParentNegated = this.negated;
    if (this.$attrs.codeListMap) {
      this.codeListMap = deepClone(this.$attrs.codeListMap);
    }
  },
  methods: {
    // 罗马模式 提交入参
    getRomaParams() {
      return this.filters.map((item) => {
        const v = item.childConditions[0];
        const isBetween = ["between", "notBetween"].includes(v.compareType);
        return {
          andor: "and",
          fieldName: v.letfFilterField,
          fieldType: v.fieldType,
          op: v.compareType,
          value: !isBetween ? v.showRightField : "",
          minValue: isBetween ? v.between[0] : "",
          maxValue: isBetween ? v.between[1] : "",
        };
      });
    },
    negatedChange(val) {
      this.filterParentNegated = val;
      this.$emit("update:negated", val);
    },
    // 罗马模式编辑回显
    getRomaViewTransferData(list) {
      return list.map((v) => {
        const filterItem = createFilterGroupItem();
        const isBetween = ["between", "notBetween"].includes(v.op);
        return {
          ...filterItem,
          childConditions: [
            {
              ...filterItem.childConditions[0],
              letfFilterField: v.fieldName,
              structWid: v.fieldName,
              fieldType: v.fieldType,
              compareType: v.op,
              showRightField: isBetween
                ? `${v.minValue}|${v.maxValue}`
                : v.value,
              rightFilterField: isBetween
                ? `${v.minValue}|${v.maxValue}`
                : v.value,
              between: [v.minValue, v.maxValue],
            },
          ],
        };
      });
    },
    filterTplValidator() {
      let isLegal = true;
      let validateName = "";
      this.filters.forEach((v, i) => {
        if (i === 0) {
          v.operator = "";
        }
        v.childConditions.forEach((t, ti) => {
          if (ti === 0) {
            t.operator = "";
          }
        });
      });
      if (!this.filters.length && this.isRequired) {
        this.$message.warning(`请添加${this.tips}！`);
        isLegal = false;
      } else {
        this.filters.forEach((v) => {
          v.childConditions.forEach((t) => {
            // 字段和比较符号必须的
            if (!t.structWid || !t.compareType) {
              isLegal = false;
              validateName = "字段和比较符号";
            }
            // between的校验
            if (
              ["BETWEEN", "NOT BETWEEN", "between", "notBetween"].includes(
                t.compareType
              ) &&
              (!t.between[0] || !t.between[1])
            ) {
              isLegal = false;
              validateName = "between";
            }
            // IS NOT NULL和IS NULL的校验
            if (
              (!t.showRightField &&
                ![
                  "IS NOT NULL",
                  "IS NULL",
                  "notNull",
                  "isNull",
                  "isEmpty",
                  "notEmpty",
                  "=",
                ].includes(t.compareType)) ||
              !t.letfFilterField
            ) {
              isLegal = false;
              validateName = "IS NOT NULL";
            }
          });
        });
        if (!isLegal) {
          this.$message.warning(`请把${this.tips}填写完！`);
          // this.$message.warning(validateName)
        }
      }
      return isLegal;
    },
    btnAddGroup() {
      if (this.disabled) return;
      if (!this.filters) {
        this.filters = [];
      }
      this.filters.push(createFilterGroupItem());
    },
  },
};
</script>

<style scoped lang="less">
.filter-tpl-pro {
  .color-theme {
    color: var(--color-primary);
  }
}
</style>

<style lang="less">
.jzliu-bi-filter-tpl-pro {
  .flex {
    display: flex;
  }

  .items-center {
    align-items: center;
  }

  .justify-between {
    justify-content: space-between;
  }

  .mr8 {
    margin-right: 8px;
  }
  .ml6 {
    margin-left: 6px;
  }
  .w210 {
    width: 210px;
  }
}
</style>
